import { render, staticRenderFns } from "./receipt-card-package-qr-code.vue?vue&type=template&id=2f4ebd58"
import script from "./receipt-card-package-qr-code.vue?vue&type=script&lang=js"
export * from "./receipt-card-package-qr-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports